import { useEffect, useState } from "react";

type Kind = "info" | "success" | "error";
interface ToastMsg {
  id: number;
  text: string;
  kind: Kind;
}

let counter = 0;
const TARGET = "proofbox-toast";

export function toast(text: string, kind: Kind = "info") {
  window.dispatchEvent(new CustomEvent(TARGET, { detail: { text, kind, id: ++counter } }));
}

export function Toaster() {
  const [items, setItems] = useState<ToastMsg[]>([]);
  useEffect(() => {
    const onToast = (e: Event) => {
      const msg = (e as CustomEvent).detail as ToastMsg;
      setItems((cur) => [...cur, msg]);
      setTimeout(() => setItems((cur) => cur.filter((m) => m.id !== msg.id)), 4000);
    };
    window.addEventListener(TARGET, onToast);
    return () => window.removeEventListener(TARGET, onToast);
  }, []);
  return (
    <>
      {items.map((m, i) => (
        <div
          key={m.id}
          className={`toast ${m.kind}`}
          style={{ bottom: 18 + i * 56 }}
          role="status"
        >
          {m.text}
        </div>
      ))}
    </>
  );
}
